module.exports = __webpack_public_path__ + "img/smart_appearance.038fb85d.png";